// FormController as first element: first controller on the list below that imports jquery module will crasch when jquery.js is not present on the site.
import FormController from './components/RunTime/FormsController';
FormController.init();

import TooltipController from './components/RunTime/TooltipController';
import IframesController from './components/RunTime/IframesController';
import NavigationController from './components/RunTime/NavigationController';
import LinkController from './components/RunTime/LinkController';
import OverlayController from './components/RunTime/OverlayController';
import EditorInfoController from './components/RunTime/EditorInfoController';
import URLParamsController from './components/RunTime/URLParamsController';
import ImageCreditsController from './components/RunTime/ImageCreditsController';
import ekkoLightbox from 'ekko-lightbox'; // eslint-disable-line no-unused-vars

require('./components/Extensions');
require('bootstrap\\js\\collapse.js');
require('bootstrap\\js\\modal.js');
require('bootstrap\\js\\tab.js');
require('bootstrap\\js\\transition.js');
require('./components/RunTime/YoutubeAutoplay.js');
require('./components/RunTime/LazyLoadingController'); // used for maps
require('./components/plugins/AnchorOffsets');
require('./components/RunTime/LozadController');
require('./components/RunTime/ServiceWorkerController');
require('./components/plugins/query.js');


//WaypointContoller.init(); //can't find any use of it
NavigationController.init(); //above the fold - fire immediately
TooltipController.init(); //useage too general
IframesController.init(); //useage too general
LinkController.init(); //can we narrow down where used?
OverlayController.init(); //can we narrow down where used?
EditorInfoController.init(); //runtime
URLParamsController.init(); //runtime
ImageCreditsController.init(); //runtime
